import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  generateZoomCallAiStatus,
  GenerateZoomCallAiStatusResponse,
} from "@/modules/zoom-calls/api";

export const useGenerateZoomCallAiStatus = (zoomCallUid: string) => {
  const queryClient = useQueryClient();

  const mutation = useMutation<GenerateZoomCallAiStatusResponse, Error, void>({
    mutationFn: () => generateZoomCallAiStatus(zoomCallUid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["lead-activity"] });
      queryClient.invalidateQueries({ queryKey: ["getZoomCalls"] });
      queryClient.invalidateQueries({ queryKey: ["getZoomCallsFlat"] });
      queryClient.invalidateQueries({
        queryKey: ["zoom-call-detail", zoomCallUid],
      });
    },
  });

  return {
    generate: mutation.mutate,
    isLoading: mutation.isPending,
    error: mutation.error,
  };
};
